import React from "react";
import * as Yup from "yup";
import InputField from "@/components/form/InputField";
import SelectField from "@/components/form/SelectField";
import CheckboxField from "../form/CheckboxField";
import { Grid } from "@radix-ui/themes";

export const fileInputValidationSchema = {
  options: Yup.object()
    .nullable()
    .shape({
      file: Yup.object()
        .nullable()
        .shape({
          accept: Yup.string().required("File type is required"),
          max_files: Yup.number()
            .required("Number of files is required")
            .min(1, "Must allow at least 1 file"),
          public: Yup.boolean(),
        }),
    }),
};

const FileInputDisplayOptions = () => {
  return (
    <>
      <Grid columns="2" gap="4" style={{ marginTop: "16px" }}>
        <SelectField
          name="options.file.accept"
          label="Allowed file types"
          type="string"
          required
        >
          <SelectField.Item value="*/*">All files</SelectField.Item>
          <SelectField.Item value="image/*">Images</SelectField.Item>
          <SelectField.Item value="application/pdf">PDFs</SelectField.Item>
          <SelectField.Item value=".doc,.docx">Word documents</SelectField.Item>
          <SelectField.Item value=".xls,.xlsx">
            Excel spreadsheets
          </SelectField.Item>
        </SelectField>

        <InputField
          name="options.file.max_files"
          label="Number of files allowed for upload"
          type="number"
          required
        />
      </Grid>
      <CheckboxField
        name="options.file.public"
        label="Public"
        description="If checked, the files will be public and can be accessed by anyone anywhere in the world."
      />
    </>
  );
};

export default FileInputDisplayOptions;
